export default "__VITE_ASSET__2ddf7a11__"